module.exports = __webpack_public_path__ + "img/rrbit.0a5b33b0.png";